export default __webpack_public_path__ + "static/media/giftWelcome-bg.62bcc3f7.webp";